// CTAGroupV3 — anon-only CTAs: "Accedi" (ghost) + "Prova Ora" (blue).
import React from "react";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import useAuthCTA from "@/hooks/useAuthCTA";
import { setAuthIntent } from "@/lib/authIntent";
import { useAnalytics } from "@/components/AnalyticsTracker";

export default function CTAGroupV3() {
    const { t } = useTranslation("header_v3");
    const authCTA = useAuthCTA();
    const { trackEvent } = useAnalytics();

    const handleSignup = () => {
        trackEvent("header_v3_anon_cta_click", { cta: "prova_ora" });
        setAuthIntent({ action: "signup", source: "header_v3_cta" });
        authCTA.signup();
    };

    const handleLogin = () => {
        trackEvent("header_v3_anon_cta_click", { cta: "accedi" });
        authCTA.login();
    };

    return (
        <div className="flex items-center gap-2">
            <button
                type="button"
                onClick={handleLogin}
                data-testid="header-v3-cta-accedi"
                className="hidden sm:inline-flex items-center px-4 py-2 rounded-lg text-sm font-medium text-white/90 hover:text-white hover:bg-white/[0.04] transition-colors"
            >
                {t("cta.accedi")}
            </button>
            <button
                type="button"
                onClick={handleSignup}
                data-testid="header-v3-cta-prova"
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-semibold text-white transition-all shadow-[0_4px_14px_rgba(255, 255, 255,0.35)] hover:shadow-[0_6px_20px_rgba(255, 255, 255,0.5)]"
                style={{ backgroundColor: "#FFFFFF" }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#EDEDED"; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#FFFFFF"; }}
            >
                <span>{t("cta.prova")}</span>
                <ArrowRight className="w-4 h-4" />
            </button>
        </div>
    );
}
